"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RollupFieldLogic = void 0;
var rollup_fieldtype_1 = require("./rollup.fieldtype");
Object.defineProperty(exports, "RollupFieldLogic", { enumerable: true, get: function () { return rollup_fieldtype_1.RollupFieldLogic; } });
